import { render, staticRenderFns } from "./contactFollowModify.vue?vue&type=template&id=3ce60bcb&scoped=true"
import script from "./contactFollowModify.vue?vue&type=script&lang=js"
export * from "./contactFollowModify.vue?vue&type=script&lang=js"
import style0 from "./contactFollowModify.vue?vue&type=style&index=0&id=3ce60bcb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce60bcb",
  null
  
)

export default component.exports